import { cloneDeep } from 'lodash';
import { RequestVacationsService } from '@/services/request-vacations.service';
import { get } from '@/helpers/httpHandler';
import { defaultChannel, echo } from '@/helpers/pusher';

export default {
  getRequestVacations({ commit }, { params } = {}) {
    return RequestVacationsService.getList({
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setRequestVacationsFilters', cloneDeep(params.filters));
      commit(
        'setRequestVacationsPaginationOptions',
        cloneDeep(params.paginationOptions)
      );

      return response;
    });
  },

  retrieveRequestVacation(_, subscriptionId) {
    return RequestVacationsService.getById(subscriptionId);
  },

  updateRequestVacation(_, { subscriptionId, subscription }) {
    return RequestVacationsService.update(subscriptionId, subscription);
  },

  getStatuses({ commit }) {
    return RequestVacationsService.getStatuses().then(response => {
      return response;
    });
  },

  getQTYRequestVacations({ commit }) {
    return get(`/ereporter/request-vacations/count-new-request-vacations`).then(
      response => {
        commit('setRequestVacationsBadgeQTY', response.data.data.new_requests);
        commit(
          'ereporter/setEreporterChip',
          Boolean(response.data.data.new_requests),
          { root: true }
        );
        return response;
      }
    );
  },

  getActualQTYRequestVacations({ commit }) {
    echo
      .channel(defaultChannel)
      .listen(
        '.App\\Events\\RequestVacation\\CountNewRequestVacation',
        function(data) {
          commit('setRequestVacationsBadgeQTY', data.new_requests);
          commit('ereporter/setEreporterChip', Boolean(data.new_requests), {
            root: true
          });
        }
      );
  }
};
